import { Navigate } from "react-router-dom";
import { useAuth, hasRole } from "@/lib/auth";

function FullScreenLoader() {
  return (
    <div
      className="min-h-screen flex items-center justify-center text-white/50 gap-3"
      data-testid="route-loader"
    >
      <div className="w-7 h-7 border-2 border-[#C5A880] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export default function ProtectedRoute({ children, minRole = "staff" }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/" replace />;
  if (!hasRole(user.role || "staff", minRole)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
